import GSwitch from './GSwitch.vue';

export default GSwitch;

export { GSwitch };
